"use client";
import type { FC } from "react";
import Image from "next/image";

import { useWindowSize } from "~/client/hooks/useWindowSize";

export const AuthLogo: FC = () => {
	const { width } = useWindowSize();

	const size = width > 2100 ? 325 : 150;

	return (
		<Image
			src="/logo-2500.png"
			alt="Vita Learning logo"
			height={size}
			width={size}
			priority
		/>
	);
};
